<script setup lang="ts">
    import { watch } from 'vue';
    import { useAskMeStore } from '../stores/ask-me';
    import { __ } from '../stores/expressions';
    import RecentChatsItem from './RecentChatsItem.vue';
    import { useRoute } from 'vue-router';

    const ask_me = useAskMeStore();
    const route = useRoute();

    watch(
        [() => route.params.chat],
        (chat) => {
            ask_me.loadRecentChats();
        },
        { immediate: true, deep: true }
    );
</script>

<template>
    <div
        class="flex-grow bg-linear-135 text-white from-primary-beet from-20% to-primary-blueberry overflow-y-scroll custom-scrollbar pt-14"
        style="--scrollbar-thumb: #fff; --scrollbar-track: rgba(255, 255, 255, 0.25)"
    >
        <nav class="px-4" :aria-label="__('recent-chats')">
            <ul>
                <li v-for="item in ask_me.recentChats" :key="item.group">
                    <h3 class="heading-sm px-2 mt-7 first-letter:capitalize mb-1">
                        {{ item.group }}
                    </h3>
                    <ul>
                        <RecentChatsItem v-for="chat in item.chats" :key="chat.id" :chat="chat" />
                    </ul>
                </li>
            </ul>
        </nav>
    </div>
</template>
